import { createSlice } from "@reduxjs/toolkit";
import getReducersLayout from "../utils/getReducersLayout";

// import { Iuser } from "@api/types/user";

const initialState = {
  coinflipGames: [],
  jackpotGames: [],
};

//
// TEMP: fake data
//
// const fakeLoggedInUser: Iuser = {
//   id: "9e0006ac-c084-45d2-a6ef-133f5a397370",
//   uid: "9e0006ac-c084-45d2-a6ef-133f5a397370",
//   username: "loggedindev",
//   wallet_address: "0x0000000000000000000000000000000000000000",
//   balance: 1234,
//   experience: 1,
//   level: 20,
//   avatar_url:
//     "https://image.binance.vision/editor-uploads-original/9c15d9647b9643dfbc5e522299d13593.png",
//   avatar_generated: false,
//   is_staff: false,
//   referral_code: "test123",
//   statistics: {
//     id: "9e0006ac-c084-45d2-a6ef-133f5a397370",
//     total: {
//       total: 80,
//       games_won: 41,
//       games_lose: 29,
//       games_draw: 10,
//       profits: 500,
//       wagered: 123456,
//       max_profit: 5561,
//     },
//     coinflip: {
//       total: 80,
//       games_won: 41,
//       games_lose: 29,
//       games_draw: 10,
//       profits: 500,
//       wagered: 123456,
//       max_profit: 5561,
//     },
//   },
// };
// const fakeUser1: Iuser = {
//   id: "9e0006ac-c084-45d2-a6ef-133f5a397371",
//   uid: "9e0006ac-c084-45d2-a6ef-133f5a397371",
//   username: "fakeuser1",
//   wallet_address: "0x0000000000000000000000000000000000000001",
//   balance: 1234,
//   experience: 1,
//   level: 20,
//   avatar_url:
//     "https://image.binance.vision/editor-uploads-original/9c15d9647b9643dfbc5e522299d13593.png",
//   avatar_generated: false,
//   is_staff: false,
//   referral_code: "test123",
//   statistics: {
//     id: "9e0006ac-c084-45d2-a6ef-133f5a397371",
//     total: {
//       total: 80,
//       games_won: 41,
//       games_lose: 29,
//       games_draw: 10,
//       profits: 500,
//       wagered: 123456,
//       max_profit: 5561,
//     },
//     coinflip: {
//       total: 80,
//       games_won: 41,
//       games_lose: 29,
//       games_draw: 10,
//       profits: 500,
//       wagered: 123456,
//       max_profit: 5561,
//     },
//   },
// };
// const fakeUser2: Iuser = {
//   id: "9e0006ac-c084-45d2-a6ef-133f5a397372",
//   uid: "9e0006ac-c084-45d2-a6ef-133f5a397372",
//   username: "fakeuser2",
//   wallet_address: "0x0000000000000000000000000000000000000002",
//   balance: 1234,
//   experience: 1,
//   level: 20,
//   avatar_url:
//     "https://image.binance.vision/editor-uploads-original/9c15d9647b9643dfbc5e522299d13593.png",
//   avatar_generated: false,
//   is_staff: false,
//   referral_code: "test123",
//   statistics: {
//     id: "9e0006ac-c084-45d2-a6ef-133f5a397372",
//     total: {
//       total: 80,
//       games_won: 41,
//       games_lose: 29,
//       games_draw: 10,
//       profits: 500,
//       wagered: 123456,
//       max_profit: 5561,
//     },
//     coinflip: {
//       total: 80,
//       games_won: 41,
//       games_lose: 29,
//       games_draw: 10,
//       profits: 500,
//       wagered: 123456,
//       max_profit: 5561,
//     },
//   },
// };
// const fakeCoinflipGame: Icoinflip = {
//   id: 12345,
//   // heads_user: null,
//   // tails_user: null,
//   // winner_id: null,
//   // result: null,
//   stake: 200000,
//   reward: 200000,
//   roll: 2,
//   ticket_id: "xxxxxx",
//   ticket_hash: "xyxyxyx",
//   ticket_verify_url: "https://example.com",
// };
// const initialState: Igames = {
//   coinflipGames: [
//     {
//       // someone elses game in progress
//       id: "1234567890",
//       uid: "",
//       game: {
//         ...fakeCoinflipGame,
//         heads_user: fakeUser1,
//         tails_user: fakeUser2,
//       },
//       creator: fakeUser1,
//       winner_id: fakeUser1,
//       type: "cf",
//       gameStats: null,
//       max_players: 2,
//       prize: 200000,
//       is_private: false,
//       is_draw: false,
//       status: "started",
//       created_at: 1645302861,
//       started_at: 1645302861,
//       ended_at: 0,
//     },
//     {
//       // our game - winner!
//       id: "1234567890",
//       uid: "",
//       game: {
//         ...fakeCoinflipGame,
//         heads_user: fakeLoggedInUser,
//         tails_user: fakeUser1,
//       },
//       creator: fakeLoggedInUser,
//       winner_id: fakeLoggedInUser,
//       type: "cf",
//       gameStats: null,
//       max_players: 2,
//       prize: 200000,
//       is_private: false,
//       is_draw: false,
//       status: "finished",
//       created_at: 1645302861,
//       started_at: 1645302861,
//       ended_at: 0,
//     },
//     {
//       // waiting for opponent to join
//       id: "1234567890",
//       uid: "",
//       game: { ...fakeCoinflipGame, tails_user: fakeUser2 },
//       creator: fakeUser2,
//       type: "cf",
//       gameStats: null,
//       max_players: 2,
//       prize: 599999,
//       is_private: false,
//       is_draw: false,
//       status: "active",
//       created_at: 1645302861,
//       started_at: 1645302861,
//       ended_at: 0,
//     },
//     {
//       // someone elses game in progress
//       id: "1234567890",
//       uid: "",
//       game: {
//         ...fakeCoinflipGame,
//         heads_user: fakeUser1,
//         tails_user: fakeUser2,
//       },
//       creator: fakeUser1,
//       type: "cf",
//       gameStats: null,
//       max_players: 2,
//       prize: 200000,
//       is_private: false,
//       is_draw: false,
//       status: "started",
//       created_at: 1645302861,
//       started_at: 1645302861,
//       ended_at: 0,
//     },
//   ],
// };

const gameSlice = createSlice({
  initialState,
  name: "gameData",
  reducers: {
    ...getReducersLayout(initialState),
  },
});

export const { setData, resetData } = gameSlice.actions;
export default gameSlice;
